import Pusher from 'pusher-js';

const parsedLocalStorage = JSON.parse(localStorage.getItem(`persist:root`));

const pusher = new Pusher('870ce22f64d48e7f1dbd', {
  cluster: 'ap2',
  authEndpoint: 'https://staging.backend.carchaser.ca/broadcasting/auth', // Your server's authorization endpoint
  auth: {
    headers: {
      Authorization: `Bearer ${parsedLocalStorage?.auth?.token}`,
    },
  },
});

export { pusher };
